var React = require('react');

function RubyLogo (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Slice"),React.createElement("g",{"stroke":"#FF003D","fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round","key":1},[React.createElement("path",{"d":"M20.38 38.892c.154.214.363.32.626.32.264 0 .472-.106.626-.32l17.356-24.305c.339-.478.335-.953-.012-1.425l-7.44-10.054c-.159-.21-.37-.316-.634-.316H11.114c-.264 0-.475.105-.634.316L3.037 13.156c-.347.472-.351.947-.013 1.425l17.357 24.31zM39.213 13.875H2.798","key":0}),React.createElement("path",{"d":"M13.846 13.877l7.16-11.085 7.16 11.085M10.742 2.885l10.264 36.323M31.271 2.885L21.006 39.208","key":1})])]);
}

RubyLogo.defaultProps = {"width":"42","height":"42","viewBox":"0 0 42 42"};

module.exports = RubyLogo;

RubyLogo.default = RubyLogo;
